export default __webpack_public_path__ + "static/media/chat-icon.09334cf2.svg";